import { render, staticRenderFns } from "./DefaultLear.vue?vue&type=template&id=af8365f2&scoped=true&"
import script from "./DefaultLear.vue?vue&type=script&lang=js&"
export * from "./DefaultLear.vue?vue&type=script&lang=js&"
import style0 from "./DefaultLear.vue?vue&type=style&index=0&id=af8365f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8365f2",
  null
  
)

export default component.exports